import { Component, ViewChild, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { jqxGridComponent } from '../../../../assets/jqwidgets-ts/angular_jqxgrid';

import { _RuleService } from '../../../ng1-services/rule.service';
import { _RuleConditionService } from '../../../ng1-services/rule-condition.service';
import { _Ng1UserService } from '../../../ng1-services/user.service';
import { _GridService } from '../../../ng1-services/grid.service';

import { Grid } from '../../../interfaces/grid.interface';
import {_OrganizationService} from "../../../services/organization.service";

declare var jQuery:any;
declare var $ :any;
declare var showErrorMessage;
declare var showSuccessMessage;

@Component({
  selector: 'timing',
  templateUrl: './timing.component.html',
  styleUrls: ['./timing.component.css'],
})

export class TimingBranch implements OnInit {

  @ViewChild('conditionsGrid') conditionsGrid: jqxGridComponent;

  //grid settings
  private conditionsSettings: Grid;
  private organization: any;

  constructor (private titleService: Title, private organizationservice: _OrganizationService, private ruleconditionservice: _RuleConditionService, private gridservice: _GridService) { }

  ngOnInit() {
    this.titleService.setTitle("WiseRisk | Timing Rules");

    this.organizationservice.getOrganization().subscribe(
      result => this.organization = result
    );

    // ------------------------------------------------
    // Conditions
    // ------------------------------------------------
    this.loadConditions();

    $(document).ready(function() {

      // ------------------------------------------------
      // Schedule
      // ------------------------------------------------

      var startTimeCount = 0;

      var blockNoStartTimes =
        `<div class="form-group" id="addStartTime">
              <label class="col-sm-2 control-label">At exactly</label>
              <div class="col-sm-1" style="padding-right:0px">
                  <a class="btn form-control-static addStartTime btn-sm" href="#" role="button" title="Add new start time">
                      <span class="glyphicon glyphicon-plus"></span>
                  </a>
              </div>
              <div class="col-sm-3" style="padding-left:0px">
                  <p class="form-control-static"><i>Add new start time</i></p>
              </div>
           </div>`;
      var blockStartTime0 =
        `<div class="form-group" style="margin-bottom:5px" id="startTime0">
              <label for="startTime" class="col-sm-2 control-label">At exactly</label>
              <div class="col-sm-3">
                  <div class="startTime"></div>
              </div>
              <div class="col-sm-1">
                  <a class="btn form-control-static removeStartTime btn-sm" href="#" role="button" title="Remove this start time">
                      <span class="glyphicon glyphicon-remove" style="color:#DB0000"></span>
                  </a>
              </div>
          </div>`;
      var blockStartTimeN =
        `<div class="form-group" style="margin-bottom:5px">
              <div class="col-sm-2"></div>
              <div class="col-sm-3">
                  <div class="startTime"></div>
              </div>
              <div class="col-sm-1">
                  <a class="btn form-control-static removeStartTime btn-sm" href="#" role="button" title="Remove this start time">
                      <span class="glyphicon glyphicon-remove" style="color:#DB0000"></span>
                  </a>
              </div>
          </div>`;
      var blockAddStartTime =
        `<div class="form-group" id="addStartTime">
              <div class="col-sm-1" style="padding-right:0px">
                  <a class="btn form-control-static addStartTime btn-sm" href="#" role="button" title="Add new start time">
                      <span class="glyphicon glyphicon-plus"></span>
                  </a>
              </div>
              <div class="col-sm-3" style="padding-left:0px">
                  <p class="form-control-static"><i>Add new start time</i></p>
              </div>
           </div>`;

      function setNextScheduledTime(json) {
        if (json.nextScheduledRebalance) {
          $("#nextScheduledTime").text("Next currently scheduled start time: " + json.nextScheduledRebalance).removeClass("alert-warning").addClass("alert-info");
        }
        else {
          $("#nextScheduledTime").text("No times currently scheduled.").removeClass("alert-info").addClass("alert-warning");
        }
      }

      function setScheduleTimeZone(json) {
        $("#scheduleTimeZone").text(json.scheduleTimeZone);
      }

      function addStartTime(startTime) {
        if (startTimeCount==0) {
          $("#addStartTime").remove();
          $("#startTimeGroup").append(blockStartTime0);
          $("#startTimeGroup").append(blockAddStartTime);
          $("#scheduleValues").removeAttr("disabled");
        }
        else {
          $("#addStartTime").before(blockStartTimeN);
        }
        var newStartTime = $("#addStartTime").prev().find('.startTime');
        newStartTime.jqxDateTimeInput({width: '100%', formatString: "HH:mm:ss", showTimeButton: true, showCalendarButton: false});
        if (startTime) {
          newStartTime.val(startTime);
        }
        startTimeCount++;
      }

      function addStartTimeClick(e) {
        e.preventDefault();
        addStartTime(undefined);
        $('#jqxTabs').jqxTabs({height:"100%"});
      }

      function removeStartTimeClick(e) {
        e.preventDefault();
        var formGroup = $(this).parents('.form-group');
        if (startTimeCount==1) {
          $("#startTimeGroup").html(blockNoStartTimes);
          $("#scheduleValues").attr("disabled",true);
        }
        else if (formGroup.attr("id") == "startTime0") {
          var nextStartTime = formGroup.next().find('.startTime').val();
          formGroup.find('.startTime').val(nextStartTime);
          formGroup.next().remove();
        }
        else {
          formGroup.remove();
        }
        startTimeCount--;
        $('#jqxTabs').jqxTabs({height:"100%"});
      }

      var initTabSchedule = function () {

        $("#scheduleLoader").jqxLoader({ width: 100, height: 60, imagePosition: 'top' });
        $('#scheduleLoader').jqxLoader('open');

        let rule:any = {};

        // Set values from server.
        $.getJSON("/ajax/rules/0", function(json) {

          rule = json;

          $('#scheduleLoader').jqxLoader('close');

          // Set up initial controls.

          // Next Scheduled Time.
          setNextScheduledTime(json);

          // Schedule Time-Zone.
          setScheduleTimeZone(json);

          // Start Times.
          $("#startTimeGroup").append(blockNoStartTimes);
          var startTimes = json.scheduleStartTimes;
          if (startTimes) {
            for (var i=0; i < startTimes.length; i++) {
              addStartTime(startTimes[i]);
            }
          }
          $("#startTimeGroup").on("click",".addStartTime",addStartTimeClick);
          $("#startTimeGroup").on("click",".removeStartTime",removeStartTimeClick);

          // Interval.
          if (json.scheduleDailyInterval) {
            $("#interval").val(json.scheduleDailyInterval);
          }

          $('#jqxTabs').jqxTabs({height:"100%"});
        });

        // Set up form validation.
        $('#formSchedule').jqxValidator({
          rules: [
            { input: '#interval', message: 'Must be a number > 0!', action: "keyup blur", rule: function() {
              var interval = $('#interval').val();
              if (interval!="") {
                interval = Math.max(Math.floor($('#interval').val()),1);
                $('#interval').val(interval);
              }
              return true;
            }
            }
          ]
        });
        $("#saveSchedule").click(function () {
          var validationResult = function (isValid) {
            if (isValid) {

              // Start Times.
              var startTimes = $(".startTime");
              var startTimesArr = [];
              startTimes.each(function( index ) {
                startTimesArr.push($(this).val());
              });

              // Interval.
              var interval = $("#interval").val();
              if (startTimes.length>0) {
                interval = Math.max(interval,1);
                $("#interval").val(interval);
              }

              rule.scheduleStartTimes = startTimesArr;
              rule.scheduleDailyInterval = interval;

              // Put.
              $.ajax({
                url: "/ajax/rules",
                type: 'PUT',
                dataType: 'json',
                data: JSON.stringify([ rule ]),
                contentType: 'application/json',
                success: function(data, status, jqXHR) {
                  setNextScheduledTime(data[0]);
                  setScheduleTimeZone(data[0]);
                  $("#nextScheduledTime").hide().fadeIn();
                  showSuccessMessage($("#scheduleResultStatus"), "Successfully saved.");
                },
                error:function(jqXHR, status, error) {
                  showErrorMessage($("#scheduleResultStatus"), "Could not save: " + (error?error:status));
                }
              });

            }
          };
          $('#formSchedule').jqxValidator('validate', validationResult);
        });

      };

      // ------------------------------------------------
      // Advanced Conditions
      // ------------------------------------------------
      $("#ruleAdvancedConditionPanel")
        .click(
          function() {
            if ($('#ruleAdvancedConditionPanel span').hasClass('glyphicon-chevron-down')) {
              $('#ruleAdvancedConditionPanel')
                .html(
                  '<span class="glyphicon glyphicon-chevron-up"></span> Hide Details');
            } else {
              $('#ruleAdvancedConditionPanel')
                .html(
                  '<span class="glyphicon glyphicon-chevron-down"></span> Show Details');
            }
            //TODO fix hack
            setTimeout(function() { $('#jqxTabs').jqxTabs({height:"100%"}); }, 300);
          });

      var initTabConditions = function () {
      };

      $('#jqxTabs').jqxTabs({
        width : '100%', height: '100%',
        initTabContent: function (tab) {
          switch (tab) {
            case 0:
              initTabSchedule();
              break;
            case 1:
              initTabConditions();
              break;
          }
        }
      });
    });
  }

  loadConditions (){
    this.conditionsSettings = null;
    this.ruleconditionservice.GetRuleConditions().then((data) => {
      var msgContainer = "conditionsMsg";
      var accounts = this.gridservice.GetAccountDataAdapter(false).records;
      var accountGroups = this.gridservice.GetAccountGroupDataAdapter().records;
      var entityDropDown = null;
      var source = {
        id : 'ruleConditionId',
        localdata: data,
        datafields : [
          {
            name : 'ruleConditionId',
            type : 'int'
          }, {
            name : 'EntityTypeDisplay',
            value: "entityType",
            values: {
              source: this.gridservice.GetEntityTypeDataAdapter().records,
              value: 'value',
              name: 'display'
            }
          }, {
            name : 'entityType',
            type : 'string'
          }, {
            name : 'EntityIDDisplay',
            value: "entityId",
            values: {
              source: accounts,
              value: 'entityId',
              name: 'display'
            }
          }, {
            name : 'entityId',
            type : 'string'
          }, {
            name : 'CurrencyPairDisplay',
            value : 'currencyPair',
            values: {
              source: this.gridservice.GetCurrencyPairDataAdapter(true).records,
              value: 'currencyPair',
              name: 'currencyPair'
            }
          }, {
            name : 'currencyPair',
            type : 'string'
          },
          {
            name : 'CriteriaDisplay',
            value : 'criteria',
            values: {
              source: this.gridservice.GetConditionCriteriaDataAdapter().records,
              value: 'value',
              name: 'display'
            }
          }, {
            name : 'criteria',
            type : 'string'
          }, {
            name : 'criteriaValue',
            type : 'float'
          }, {
            name : 'enabled',
            type : 'bool',
            editable:true
          }
        ],
        updaterow : (rowid, rowdata, commit) => {
          //New Row
          if(rowdata.rowId < 1){
            this.ruleconditionservice.CreateRuleCondition(rowdata).then((data) => {
              this.gridservice.SuccessMsg(msgContainer, 'Timing Condition Added');
              this.loadConditions();
            },(data) => {
              this.gridservice.ErrorMsg(msgContainer, data);
            });
          }else{
            this.ruleconditionservice.UpdateRuleCondition(rowdata).then((data) => {
              commit(true);
              this.gridservice.SuccessMsg(msgContainer, 'Timing Condition Updated');
              this.loadConditions();
            },(data) => {
              this.gridservice.ErrorMsg(msgContainer, data);
            });
          }
        },
        deleterow: (rowdata) => {
          this.ruleconditionservice.DeleteRuleCondition(rowdata.ruleConditionId).then((data) => {
            this.loadConditions();
            this.gridservice.SuccessMsg(msgContainer, 'Timing Condition Deleted');
            //this.loadConditions();
          },(data) => {
            this.gridservice.ErrorMsg(msgContainer, data);
          });
        },
        refresh:() => {
          this.loadConditions();
        },
        getGrid: () => { return this.conditionsGrid; }
      };
      this.conditionsSettings = {
        source: source,
        dataAdapter: new $.jqx.dataAdapter(source),
        columns:[{
          text : 'Scope',
          columntype : 'dropdownlist',
          datafield : 'entityType',
          displayfield : "EntityTypeDisplay",
          width : '150',
          createeditor :(row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source : this.gridservice.GetEntityTypeDataAdapter(),
              displayMember : "display",
              valueMember : "value"
            });
          },
          initeditor :(row, cellvalue, editor, celltext, cellwidth, cellheight) => {
            editor.on('change', (event) => {
              var entityType = event.args.item.value;
              this.gridservice.ConfigureEntityEditor(entityDropDown, entityType, true);
            });
          }
        }, {
          text : 'Name',
          columntype : 'dropdownlist',
          datafield : 'entityId',
          displayfield : "EntityIDDisplay",
          width : '150',
          createeditor : (row, cellvalue, editor, celltext, cellwidth, cellheight)=> {
            entityDropDown = editor;
            var entityType = this.conditionsGrid.getcellvalue(row, "entityType");
            this.gridservice.ConfigureEntityEditor(entityDropDown, entityType, false);
          },
          initeditor: (row, cellvalue, editor, celltext, cellwidth, cellheight) => {
            // set entityDropDown, so it can be configured by EntityType editor change
            entityDropDown = editor;
            var entityType = this.conditionsGrid.getcellvalue(row, "entityType");
            this.gridservice.ConfigureEntityEditor(entityDropDown, entityType, false);
          },
          cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties, rowdata) => {
            return this.gridservice.SetInitialEntityDisplay(rowdata.entityType, rowdata.entityId);
          }
        }, {
          text : 'Ccy Pair',
          columntype : 'dropdownlist',
          datafield : 'currencyPair',
          displayfield : 'CurrencyPairDisplay',
          width : '100',
          createeditor : (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source : this.gridservice.GetCurrencyPairDataAdapter(true),
              displayMember : "currencyPair",
              valueMember : "currencyPair"
            });
          }
        }, {
          text : 'Criteria',
          columntype : 'dropdownlist',
          datafield : 'criteria',
          displayfield : 'CriteriaDisplay',
          width : '200',
          createeditor : (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source : this.gridservice.GetConditionCriteriaDataAdapter(),
              displayMember : "display",
              valueMember : "value"
            });
          }
        }, {
          text : 'Value',
          columntype : 'textbox',
          datafield : 'criteriaValue',
          width : '80',
        }, {
          text : 'Enabled',
          columntype : 'checkbox',
          datafield : 'enabled',
          width : '80'
        }],
        renderstatusbar: (statusbar: any) => {
          this.gridservice.RenderStatusBar(statusbar, source);
        }
      };
    });
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/rules/timing/timing.component.ts